import { LoadingSpinner } from "../../../Libraries/Media";
import {
  React,
  useNavigate,
  useRef,
  useEffect,
  useLocation,
  Button,
  toast,
  useState,
  Box,
  EditLayoutSelectionSlider,
  EditPostMiddleForm,
  EditSidebarContent,
  EditFooterContent,
  useUpdatePostMutation,
  GetCookie,
} from "../../../Libraries/Post/EditPost/Parent/index";

const EditPost = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [updatePost, { isLoading }] = useUpdatePostMutation();

  const [data, setdata] = useState({
    selectedLayout: location.state?.hasOwnProperty("from")
      ? location.state?.ser_layout_id
      : location.state?.ser_layout_id,
    NewSelectedScreens: location.state?.hasOwnProperty("from")
      ? location.state?.screen
      : location.state?.screenfromdb,
    PostStatus: location.state?.hasOwnProperty("from")
      ? location.state?.txt_post_status
      : location.state?.txt_post_status,
    PostTitle: location.state?.hasOwnProperty("from")
      ? location.state?.txt_post_title
      : location.state?.txt_post_title,
    finalfile: location.state?.hasOwnProperty("from")
      ? {
          txt_media_streaming_link: location.state?.finalfile.link,
          txt_media_file_type: location.state?.finalfile.type,
          ser_media_id: location.state?.finalfile.ser_media_id,
        }
      : location.state?.finalfile,
    selectedDuration: location.state?.hasOwnProperty("from")
      ? location.state?.txt_post_duration
      : location.state?.txt_post_duration,
    radiobuttonvalue: "Day wise",
  });

  const posttype = useRef();

  const [sidebarrowdata, setsidebarrowdata] = useState(
    location.state?.sidebar ? location.state?.sidebar : []
  );

  const [footerrowdata, setfooterrowdata] = useState(
    location.state?.footer ? location.state?.footer : []
  );

  const handleChangeSelectedLayout = (value) => {
    setdata({
      ...data,
      selectedLayout: value,
    });
  };
  const handleChangeRadioButtonvalue = (value) => {
    setdata({
      ...data,
      radiobuttonvalue: value,
    });
  };

  const handleChangeNewSelectedScreens = (value) => {
    setdata({
      ...data,
      NewSelectedScreens: value,
    });
  };

  const handleChangeselectedDuration = (value) => {
    setdata({
      ...data,
      selectedDuration: value,
    });
  };

  const handleChangefinalfile = (value) => {
    setdata({
      ...data,
      finalfile: value,
    });
  };

  const handleChangePosttitle = (value) => {
    setdata({
      ...data,
      PostTitle: value,
    });
  };

  const handleChangePostStatus = (value) => {
    setdata({
      ...data,
      PostStatus: value,
    });
  };

  useEffect(() => {
    if (location.state === null) {
      navigate("/posts");
    }
  }, [location, navigate]);

  const handleSave = async () => {
    // these operations will make the formate as per API
    const orignal_screens = location.state?.screenfromdb?.map((eachdata) => ({
      ser_screen_id: eachdata.value,
    }));

    const new_screens = data?.NewSelectedScreens?.map((eachdata) => ({
      ser_screen_id: eachdata.value,
    }));

    switch (data.selectedLayout) {
      case "1":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            new_screens: new_screens,
            sidebar: "N/A",
            footer: "N/A",
          };
          const payload = JSON.stringify(createpostdata);
          UpdatePost(payload);
        }
        break;
      case "2":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration === "null" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            new_screens: new_screens,
            sidebar: "N/A",
            footer: footerrowdata,
          };

          const payload = JSON.stringify(createpostdata);
          UpdatePost(payload);
        }
        break;
      case "3":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: "N/A",
          };

          const payload = JSON.stringify(createpostdata);
          UpdatePost(payload);
        }
        break;
      case "4":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please select the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
          };

          const payload = JSON.stringify(createpostdata);
          UpdatePost(payload);
        }
        break;
      case "5":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: "N/A",
          };
          const payload = JSON.stringify(createpostdata);
          UpdatePost(payload);
        }
        break;
      case "6":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
          };
          const payload = JSON.stringify(createpostdata);
          UpdatePost(payload);
        }
        break;
      default:
        toast.error("Please Select the right Layout");
    }
  };

  const handlePreview = async () => {
    // these operations will make the formate as per API
    const orignal_screens = location.state?.screenfromdb?.map((eachdata) => ({
      ser_screen_id: eachdata.value,
    }));

    const new_screens = data?.NewSelectedScreens?.map((eachdata) => ({
      ser_screen_id: eachdata.value,
    }));

    switch (data.selectedLayout) {
      case "1":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else {
          const editpreviewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            screenfromdb: location.state?.screenfromdb,
            screen: data.NewSelectedScreens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            finalfile: {
              type: data.finalfile.txt_media_file_type,
              link: data.finalfile.txt_media_streaming_link,
              ser_media_id: data.finalfile.ser_media_id,
            },
            from: "editpost",
          };
          navigate(".", { state: editpreviewdata });

          navigate("/layoutpreview", { state: editpreviewdata });
        }
        break;
      case "2":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration === "null" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const editpreviewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            screenfromdb: location.state?.screenfromdb,
            screen: data.NewSelectedScreens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            finalfile: {
              type: data.finalfile.txt_media_file_type,
              link: data.finalfile.txt_media_streaming_link,
              ser_media_id: data.finalfile.ser_media_id,
            },
            from: "editpost",
          };
          navigate(".", { state: editpreviewdata });

          navigate("/layoutpreview", { state: editpreviewdata });
        }
        break;
      case "3":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const editpreviewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            screenfromdb: location.state?.screenfromdb,
            screen: data.NewSelectedScreens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            finalfile: {
              type: data.finalfile.txt_media_file_type,
              link: data.finalfile.txt_media_streaming_link,
              ser_media_id: data.finalfile.ser_media_id,
            },
            from: "editpost",
          };
          navigate(".", { state: editpreviewdata });

          navigate("/layoutpreview", { state: editpreviewdata });
        }
        break;
      case "4":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please select the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const editpreviewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            screenfromdb: location.state?.screenfromdb,
            screen: data.NewSelectedScreens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            finalfile: {
              type: data.finalfile.txt_media_file_type,
              link: data.finalfile.txt_media_streaming_link,
              ser_media_id: data.finalfile.ser_media_id,
            },
            from: "editpost",
          };
          navigate(".", { state: editpreviewdata });

          navigate("/layoutpreview", { state: editpreviewdata });
        }
        break;
      case "5":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const editpreviewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            screenfromdb: location.state?.screenfromdb,
            screen: data.NewSelectedScreens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            finalfile: {
              type: data.finalfile.txt_media_file_type,
              link: data.finalfile.txt_media_streaming_link,
              ser_media_id: data.finalfile.ser_media_id,
            },
            from: "editpost",
          };
          navigate(".", { state: editpreviewdata });

          navigate("/layoutpreview", { state: editpreviewdata });
        }
        break;
      case "6":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          new_screens === undefined ||
          new_screens === "undefined" ||
          new_screens === null ||
          new_screens === "null" ||
          new_screens.length === 0
        ) {
          toast.error("New Screen is missing");
        } else if (
          orignal_screens === undefined ||
          orignal_screens === "undefined" ||
          orignal_screens === null ||
          orignal_screens === "null" ||
          orignal_screens.length === 0
        ) {
          toast.error("Orignal Screen is missing");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post status");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const editpreviewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_post_id: location.state.ser_post_id,
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype.current.value,
            txt_post_duration: data.selectedDuration,
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            orignal_screens: orignal_screens,
            screenfromdb: location.state?.screenfromdb,
            screen: data.NewSelectedScreens,
            new_screens: new_screens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            finalfile: {
              type: data.finalfile.txt_media_file_type,
              link: data.finalfile.txt_media_streaming_link,
              ser_media_id: data.finalfile.ser_media_id,
            },
            from: "editpost",
          };
          navigate(".", { state: editpreviewdata });

          navigate("/layoutpreview", { state: editpreviewdata });
        }
        break;
      default:
        toast.error("Please Select the right Layout");
    }
  };

  const UpdatePost = async (createPostdata) => {
    const response = await updatePost(createPostdata).unwrap();
    if (
      response.message === "Post saved successfully" &&
      response.connection === "true" &&
      response.status === "true"
    ) {
      toast.success(response.message);
      navigate("/posts", {
        state: data.NewSelectedScreens,
      });
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
        <EditLayoutSelectionSlider
          data={data}
          handleChangeSelectedLayout={handleChangeSelectedLayout}
        />

        <EditPostMiddleForm
          posttype={posttype}
          data={data}
          handleChangeNewSelectedScreens={handleChangeNewSelectedScreens}
          handleChangeselectedDuration={handleChangeselectedDuration}
          handleChangefinalfile={handleChangefinalfile}
          handleChangePosttitle={handleChangePosttitle}
          handleChangePostStatus={handleChangePostStatus}
        />

        {(data?.selectedLayout === "3" ||
          data?.selectedLayout === "4" ||
          data?.selectedLayout === "5" ||
          data?.selectedLayout === "6") === true ? (
          <EditSidebarContent
            data={data}
            handleChangeRadioButtonvalue={handleChangeRadioButtonvalue}
            setRowsData={setsidebarrowdata}
            rowsData={sidebarrowdata}
          />
        ) : null}

        {/* add post form footer */}
        {(data?.selectedLayout === "2" ||
          data?.selectedLayout === "4" ||
          data?.selectedLayout === "6") === true ? (
          <EditFooterContent
            data={data}
            handleChangeRadioButtonvalue={handleChangeRadioButtonvalue}
            setRowsData={setfooterrowdata}
            rowsData={footerrowdata}
          />
        ) : null}

        <div className="row justify-content-end mr-3">
          <div className="col-1 d-flex justify-content-end">
            <Button variant="outlined" onClick={handlePreview} className="capitalized fs-14 fw-bold">
              Preview
            </Button>
          </div>
          <div className="col-1 d-flex justify-content-end">
            <Button variant="contained" onClick={handleSave} className="capitalized fs-14 fw-bold">
              Update
            </Button>
          </div>
        </div>
      </Box>
    </>
  );
};

export default EditPost;
